module.exports = __webpack_public_path__ + "static/itforge-94401210a1fec6b006a5f2f12c8f257b.svg";